import { LoadingIcon } from '@prosolve/common-components-ui'
import useQuestDashboardAuthMessage from './hooks/useQuestDashboardAuthMessage';

export default () => {

  useQuestDashboardAuthMessage((userId) => {
    sessionStorage.setItem('isQuestAssessmentDashboardAuthorized', 'true');
    sessionStorage.setItem('loggedInUserId', userId);
    window.location.reload()
  });

  return (
    <div style={{
      height: '100%',
      width: '100%',
      background: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <LoadingIcon />
    </div>
  )
}
